const styles = theme => ({
    root: {
        padding: theme.spacing(4)
    }
});
export default styles;
